// extracted by mini-css-extract-plugin
export default {"mCard":"MA-z","image":"NA-z","imageNoBackground":"OA-z","imageHasCategory":"PA-z","fullWidth":"QA-z"};